<!-- 组件说明 -->
<template>
  <div class="con">
    <div class="goodstype-box" >
      <ul class="goods-item">
        <!-- 剂型 -->
        <li v-if="jixings.length">
          <div class="type-title">剂型</div>
          <div class="typeList-box" :class="{ active: isfold0 }">
            <ul class="typeList" ref="typeList">
              <li class="c-pointer" @click="changeList(1, 4)">全部</li>
              <li
                v-for="(i, index) in jixings"
                :key="index"
                @click="changeList(i, 1)"
                class="c-pointer"
              >
                <a :class="{ activeColor: a1 == i }">{{ i }}</a>
              </li>
            </ul>
            <div @click="isfold0 = !isfold0" v-if="isShow0"  class="c-pointer">
              <div class="moreBtn" v-if="!isfold0">
                更多<img
                  :src="require('@/assets/images/icon_return.png')"
                  alt=""
                />
              </div>
              <div class="moreBtn fildBtn" v-else>
                收起<img
                  :src="require('@/assets/images/icon_return.png')"
                  alt=""
                />
              </div>
            </div>
          </div>
        </li>
        <!-- 类型 -->
        <li v-if="tags.length">
          <div class="type-title">类型</div>
          <div class="typeList-box" :class="{ active: isfold1 }">
            <ul class="typeList">
              <li class="c-pointer" @click="changeList(1, 5)">全部</li>
              <li
                v-for="(i, index) in tags"
                :key="index"
                @click="changeList(i, 2)"
                class="c-pointer"
              >
                <a :class="{ activeColor: a2 == i.code }">{{ i.label }}</a>
              </li>
            </ul>
            <div @click="isfold1 = !isfold1" v-if="isShow1"  class="c-pointer">
              <div class="moreBtn" v-if="!isfold1">
                更多<img
                  :src="require('@/assets/images/icon_return.png')"
                  alt=""
                />
              </div>
              <div class="moreBtn fildBtn" v-else>
                收起<img
                  :src="require('@/assets/images/icon_return.png')"
                  alt=""
                />
              </div>
            </div>
          </div>
        </li>
        <!-- 品牌 -->
        <li v-if="brands.length">
          <div class="type-title">品牌</div>
          <div class="typeList-box bb0" :class="{ active: isfold2 }">
            <ul class="typeList">
              <li class="c-pointer" @click="changeList(1, 6)">全部</li>
              <li
                v-for="(i, index) in brands"
                :key="index"
                @click="changeList(i, 3)"
                class="c-pointer"
              >
                <a :class="{ activeColor: a3 == i.id }">{{ i.name }}</a>
              </li>
            </ul>
            <div @click="isfold2 = !isfold2" v-if="isShow2" class="c-pointer">
              <div class="moreBtn" v-if="!isfold2">
                更多<img
                  :src="require('@/assets/images/icon_return.png')"
                  alt=""
                />
              </div>
              <div class="moreBtn fildBtn" v-else>
                收起<img
                  :src="require('@/assets/images/icon_return.png')"
                  alt=""
                />
              </div>
            </div>
          </div>
        </li>

        <!-- 价格 -->
        <!-- <li v-if="jixings.length || tags.length || brands.length">
          <div class="type-title">价格</div>
          <ul class="select-price">
            <li
              v-for="(item, index) in priceList"
              :key="index"
              @click="changePrice(item, index)"
            >
              <a class="c-pointer">{{ item.price }}</a>
            </li>
          </ul>
          <div class="filter-price">
            <input type="text" v-model="price1" />
            -<input type="text" v-model="price2" />
            <a class="c-pointer" @click="changePrice">确定</a>
          </div>
        </li> -->
      </ul>
    </div>
  </div>
</template>

<script>
//import x from ''
export default {
  components: {},
  props: ["typeList"],
  data() {
    return {
      price1: "",
      price2: "",
      priceList: [
        { price: "全部" },
        { price: "0-10" },
        { price: "10-50" },
        { price: "50-100" },
        { price: "100以上" },
      ],
      isfold0: false,
      isfold1: false,
      isfold2: false,
      isShow0: false,
      isShow1: false,
      isShow2: false,
      jixing: "",
      brandId: "",
      tagId: "",
      brands: [],
      jixings: [],
      tags: [],
      a1: null,
      a2: null,
      a3: null,
    };
  },
  created() {
    // this.getgoodslist()
    this.brands = this.typeList.brands || [];
    this.jixings = this.typeList.jixings || [];
    this.tags = this.typeList.tags || [];
    console.log( this.brands,this.typeList)
  },

  watch: {
    $route: {
      handler(t, f) {
        this.a1 = null;
        this.a2 = null;
        this.a3 = null;
      },
      immediate: true,
    },
    'typeList':{
      handler(t, f) {
        this.brands = t.brands;
        this.jixings = t.jixings;
        this.tags = t.tags;
        //console.log('-----------------typelist--------------------------');
        this.handleMoreBtn()

      },
      immediate: true,
    }

  },
  methods: {
    changePrice(item, index) {
      //console.log(index);
      switch (index) {
        case 0:
          this.price1 = null;
          this.price2 = null;
          break;
        case 1:
          this.price1 = 0;
          this.price2 = 10;
          break;
        case 2:
          this.price1 = 10;
          this.price2 = 50;
          break;
        case 3:
          this.price1 = 50;
          this.price2 = 100;
          break;
        case 4:
          this.price1 = 100;
          this.price2 = "";
          break;
      }
      this.$emit("changeLimits", this.price1, this.price2);
    },
    changeList(item, num) {
      switch (num) {
        case 1:
          this.jixing = item;
          this.a1 = item;
          break;
        case 2:
          this.tagId = item.code;
          this.a2 = item.code;
          break;
        case 3:
          this.brandId = item.id;
          this.a3 = item.id;
          break;
        case 4:
          this.jixing = "";
          this.a1 = null;
          break;
        case 5:
          this.tagId = "";
          this.a2 = null;
          break;
        case 6:
          this.brandId = "";
          this.a3 = null;
          break;
      }
      this.$emit("changeType", this.jixing, this.tagId, this.brandId);
    },
    handleMoreBtn() {
      this.$nextTick(() => {
        var x = document.querySelectorAll(".typeList");
        for (let i = 0; i < x.length; i++) {
          //console.log(x[i].clientWidth,'-------------------x[i].clientWidth---------');
          if (x[i].clientWidth >= 1004) {
            switch (i) {
              case 0:
                this.isShow0 = true;
                break;
              case 1:
                this.isShow1 = true;
                break;
              case 2:
                this.isShow2 = true;
                break;
            }
          } else {
            switch (i) {
              case 0:
                this.isShow0 = false;
                break;
              case 1:
                this.isShow1 = false;
                break;
              case 2:
                this.isShow2 = false;
                break;
            }
          }
        }
      });
    },
  },
  updated() {
  },
  mounted() {

  },
};
</script>

<style lang='scss' scoped>
.goodstype-box {
  // height: 265px;
  background-color: #ffffff;
  margin-bottom: 20px;
  width: 100%;
  .goods-item {
    border: 1px solid #f0f0f0;
    > li {
      display: flex;
      .type-title {
        width: 120px;
        text-align: center;
        //  margin-right: 20px;
        font-size: 14px;
        color: #777777;
        letter-spacing: 20px;
        flex-shrink: 0;
        line-height: 30px;
        padding-top: 20px;
        background-color: #ffffff;
        border-right:  1px solid #f0f0f0;
      }
    }
  }
}
.typeList-box {
  display: flex;
  border-bottom: 1px solid #f0f0f0;
  padding: 20px 0;
  height: 60px;
  overflow: hidden;
  width: 100%;
  justify-content: space-between;
  padding-left: 20px;
  &.bb0{
    border-bottom: 0;
  }
  .typeList {
    //  width: 800px;
    display: flex;
    flex-wrap: wrap;
    li {
      color: #656565;
      margin-right: 20px;
      line-height: 30px;

      a {
        font-size: 13px;
        color: #656565;
        white-space: nowrap;
      }
    }
  }
  .moreBtn {
    margin-right: 20px;
    white-space: nowrap;
    color: #333333;
    font-size: 12px;
    line-height: 30px;
    img {
      transform: rotate(270deg);
      margin-left: 4px;
    }
  }
}
.fildBtn {
  img {
    transform: rotate(90deg) !important;
  }
}
.active {
  height: 100%;
}
.select-price {
  display: flex;
  font-size: 13px;
  color: #656565;
  align-items: center;
  height: 65px;
  padding-left: 20px;
  li {
    margin-right: 20px;
  }
}
.filter-price {
  display: flex;
  align-items: center;
  input {
    height: 22px;
    width: 37px;
    border: 1px solid #dddddd;
    margin: 0 5px;
    text-align: center;
  }
  a {
    border: 1px solid #dddddd;
    font-size: 11px;
    color: #656565;
    height: 22px;
    width: 37px;
    text-align: center;
    line-height: 22px;
  }
}
.activeColor {
  color: #fa4b4b !important;
}
</style>


// WEBPACK FOOTER //
// src/pages/main/search/components/goods-type.vue